'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Utensils, Leaf, Compass, Video, Music } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const activities = [
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '07:00 – 08:00',
  title: 'Ăn sáng',
  desc: 'Bữa sáng khởi đầu ngày mới.',
  accent: '#e8a030'
},
{
  icon: <Leaf size={18} className="text-[#4caf7d]" />,
  time: '08:00 – 12:00',
  title: 'Green Volunteer – Chặng 2 (Khám phá và làm sạch đảo 2)',
  desc: 'Làm sạch sâu, xử lý khu vực khó và phần còn sót.',
  accent: '#4caf7d'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '12:00 – 13:30',
  title: 'Ăn trưa – nghỉ ngơi',
  desc: 'Bữa trưa và thời gian nghỉ ngơi phục hồi năng lượng.',
  accent: '#e8a030'
},
{
  icon: <Compass size={18} className="text-[#f5c96a]" />,
  time: '13:30 – 16:45',
  title: 'Setup khu truy tìm báu vật (giai đoạn 1)',
  desc: 'Dựng checkpoint, làm bảng nhiệm vụ, định hình tuyến di chuyển và trải nghiệm.',
  accent: '#f5c96a'
},
{
  icon: <Video size={18} className="text-[#a8d87a]" />,
  time: '16:45 – 17:00',
  title: 'Quay video phỏng vấn cá nhân – hậu trường',
  desc: 'Ghi lại câu chuyện và cảm xúc thật của từng đội.',
  accent: '#a8d87a'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '17:00 – 19:00',
  title: 'Ăn tối – sinh hoạt cá nhân',
  desc: 'Bữa tối và thời gian tự do cá nhân.',
  accent: '#e8a030'
},
{
  icon: <Music size={18} className="text-[#4caf7d]" />,
  time: '19:00 – 21:30',
  title: 'Đêm tài năng mở đầu',
  desc: 'Chuẩn bị và trình diễn tiết mục theo đội.',
  accent: '#4caf7d'
}];


export default function Slide12bDay3({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1622557772687-3eab6795a042"
          alt="Rừng xanh nhiệt đới Việt Nam, cây cối rậm rạp bên bờ hồ trong xanh"
          className="w-full h-full object-cover opacity-8" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a2a]/70 via-[#0a1a0f] to-[#0a1a0f]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(76,175,125,0.3)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4caf7d] inline-block" />
            Hành trình 8 ngày 7 đêm
          </div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(24px,3.5vw,48px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            NGÀY 3
          </h2>
          <h2 className="font-display font-800 text-[clamp(18px,2.5vw,32px)] leading-[1.3] tracking-tight text-gradient-green">Khám phá đảo 2 – Báu vật – Đêm tài năng

          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="section-divider" />
        </div>

        <div className="relative fade-in-up">
          <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gradient-to-b from-[#4caf7d]/60 via-[#f5c96a]/40 to-transparent" />
          <div className="flex flex-col gap-4">
            {activities.map((act, i) =>
            <div key={`d3-${i}`} className="flex items-start gap-4 pl-2">
                <div
                className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center z-10"
                style={{ background: `${act.accent}22`, border: `1.5px solid ${act.accent}55` }}>
                
                  {act.icon}
                </div>
                <div
                className="flex-1 rounded-xl p-4 transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: `${act.accent}0d`, border: `1px solid ${act.accent}22` }}>
                
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span
                    className="font-body font-700 text-[11px] tabular-nums px-2 py-0.5 rounded-full"
                    style={{ color: act.accent, background: `${act.accent}18` }}>
                    
                      {act.time}
                    </span>
                    <h3 className="font-display font-700 text-[14px] lg:text-[15px] text-[#f0ede6]">
                      {act.title}
                    </h3>
                  </div>
                  <p className="font-body text-[12px] lg:text-[13px] text-[#a0b8a8] leading-relaxed">
                    {act.desc}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SlideWrapper>);

}